import { RcFile } from 'antd/lib/upload';

export function convertFileToBase64(file: RcFile) {
  return new Promise<string>((res, rej) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      res((reader.result as string).replace('data:', '').replace(/^.+,/, ''));
    };
    reader.onerror = (error) => rej(error);
    reader.readAsDataURL(file);
  });
}
